export default 'Reset link is expired.';
